import { sortBy } from 'lodash';

export default function selectImage(formats, width) {
  const sortedFormats = sortBy(formats, 'width');

  for (let index = 0; index < sortedFormats.length; index++) {
    if (sortedFormats[index].width >= width) {
      return sortedFormats[index];
    }
  }
  return sortedFormats[formats.length - 1];
}



// WEBPACK FOOTER //
// ../src/client/utils/selectImage.js